import MediaQuery from 'src/DistributionPackages/Avaloq.NodeTypes/Resources/Private/JavaScript/Modules/MediaQuery.js'

export default class ProductStackPillNavigation {
    constructor(productStack, tiles) {
        this.productStack = productStack
        this.tiles = tiles
        this.pills = this.productStack.querySelectorAll('.js-product-stack__pill')
        this.pillDescription = this.productStack.querySelector('.js-product-stack__pill-description')
        this.setStartStyling()
        this.pillsListener()
    }

    pillsListener() {
        this.pills.forEach((pill, index) => {
            pill.addEventListener('click', () => {
                if (pill.classList.contains('js-product-stack__pill--backend')) {
                    return
                }

                this.setAllPillsStylingToUnActive()
                this.setPillStylingToActive(index)

                this.changeDescription(pill.dataset.description)
                this.scrollToTop()

                this.tiles.disableAllTiles()
                this.tiles.unFocusAllTiles()
                if (index === 0) {
                    this.tiles.enableTiles(this.tiles.tilesToPillOne)
                }
                if (index === 1) {
                    this.tiles.enableTiles(this.tiles.tilesToPillTwo)
                }
                if (index === 2) {
                    this.tiles.enableTiles(this.tiles.tilesToPillThree)
                }
            })
        })
    }

    setAllPillsStylingToUnActive() {
        this.pills.forEach((pill) => {
            pill.classList.remove('product-stack__pill--active')
        })
    }

    setPillStylingToActive(index) {
        this.pills[index].classList.add('product-stack__pill--active')
    }

    setStartStyling() {
        this.setPillStylingToActive(0)
    }

    changeDescription(newText) {
        this.pillDescription.innerText = newText
    }

    scrollToTop() {
        if (!MediaQuery.UpMd.matches) {
            return
        }
        this.productStack.scrollIntoView(true, { behavior: 'smooth', block: 'end', inline: 'nearest' })
    }
}
